import { useEffect } from 'react';
import heroMechanicImage from '@/assets/hero-premium-mechanic-service.jpg';

// Critical assets that should be preloaded
const criticalAssets = [
  { href: heroMechanicImage, as: 'image' as const, type: 'image/jpeg' }
];

export const PreloadCriticalAssets = () => {
  useEffect(() => {
    // Preload only on home route and fast connections
    const isHome = window.location.pathname === '/';
    if (!isHome) return;

    const connection = (navigator as any).connection;
    const shouldPreload = !connection || 
      (connection.effectiveType !== 'slow-2g' && 
       connection.effectiveType !== '2g' && 
       connection.downlink > 1.5);

    if (!shouldPreload) return;

    criticalAssets.forEach(asset => {
      const link = document.createElement('link');
      link.rel = 'preload';
      link.href = asset.href;
      link.as = asset.as;
      if (asset.type) link.type = asset.type;
      
      // Add to head if not already there
      if (!document.querySelector(`link[href="${asset.href}"]`)) {
        document.head.appendChild(link);
      }
    });
  }, []);

  return null;
};